
import axios, { AxiosInstance } from "axios"
import api from "@/services/api"
import { Event, EventMedia, CaseEvents } from "@/types/originatingEvents"

class EventApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async caseEventsGet (caseId: string): Promise<CaseEvents> {
		return (await this.axios.get(`/event/${caseId}`)).data
	}

	public async eventGet (caseId: string, id: string): Promise<Event> {
		return (await this.axios.get(`/event/${caseId}/${id}`)).data
	}

	public async eventMediaGet (caseId: string, eventId: string): Promise<EventMedia[]> {
		return (await this.axios.get(`/event/media/${caseId}/${eventId}`)).data
	}

	public async eventRecordMarkKey (caseId: string, eventId: string, eventRecordId: number, isKey: boolean): Promise<void> {
		await this.axios.post(`/event/setaskey/${caseId}/${eventId}/${eventRecordId}`, null, {
			params: {
				isKey
			}
		})
	}

	public async mediaMarkKey (caseId: string, clipId: string, isKey: boolean): Promise<void> {
		await this.axios.post(`/event/media/setaskey/${caseId}/${clipId}`, null, {
			params: {
				isKey
			}
		})
	}
}

const eventApi = new EventApi()
export default eventApi
